export const getIsUnderMaintenance = state => state.underMaintenance;